import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["save", "cancel"]

  connect() {
    this.form = this.element.closest("form")
    this.initialState = this.formState
    this.update = this.update.bind(this)

    this.form.addEventListener("input", this.update)
    this.form.addEventListener("change", this.update)
    this.update()
  }

  disconnect() {
    this.form.removeEventListener("input", this.update)
    this.form.removeEventListener("change", this.update)
  }

  reset() {
    this.form.reset()

    this.form.querySelectorAll("input:not([type=hidden]), select, textarea").forEach((field) => {
      field.dispatchEvent(new Event("input", { bubbles: true }))
      field.dispatchEvent(new Event("change", { bubbles: true }))
    })

    this.update()
  }

  update() {
    const changed = this.formState !== this.initialState

    this.saveTarget.disabled = !changed || !this.form.checkValidity()
    this.cancelTarget.disabled = !changed
  }

  get formState() {
    const formData = Array.from(new FormData(this.form), ([name, value]) => [
      name,
      value instanceof File ? [value.name, value.size, value.lastModified] : value
    ])
    const unnamedFiles = Array.from(this.form.querySelectorAll("input[type=file]:not([name])"), (input) =>
      Array.from(input.files, (file) => [file.name, file.size, file.lastModified])
    )

    return JSON.stringify([formData, unnamedFiles])
  }
}
